import React from "react";

import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const WarrantyDashboard = lazyLoader(
  () => import("Containers/Warranty/WarrantyDashboard/Warrantydashboard")
);

export const WarrantyList = () => {
  return (
    <Layout>
      <WarrantyDashboard />
    </Layout>
  );
};
